module.exports = __webpack_public_path__ + "img/Close.b7e90a4d.svg";